// extracted by mini-css-extract-plugin
export default {"pill":"globalLoader_pill__sC3I2","on":"globalLoader_on__Jr9F+"};